import { BaseContainerModel } from '../base-container.model';
import { bl_mrp_pi_worklog_Rowclass } from '../../dbschema';

export class MrpProcessInstanceWorklogContainerModel extends BaseContainerModel {
  bl_mrp_pi_worklog: bl_mrp_pi_worklog_Rowclass = new bl_mrp_pi_worklog_Rowclass();
}
